import React from "react";
import { productType } from "../../../types/product";
import style from "./product.module.css";
import { convertToFa } from "../../../helpers/converting";
interface prop {
  product: productType;
  width?: string;
}
const ProductSingle: React.FC<prop> = ({ product, width }) => {
  return (
    <div
      className={style["product-item"]}
      style={{
        width: width ? width : "",
      }}
    >
      <a
        rel="noopener noreferrer"
        href={`https://www.banimode.com/${product.color_link}`}
        target="_blank"
      >
        <div className={style["product-image"]}>
          <div className={style.image}>
            <img
              src={product.images.large_default[0]}
              alt="product"
              style={{
                filter: !!product.total_qty ? "unset" : "grayscale(1)",
              }}
            />
          </div>
          {!!product.product_specific_price && (
            <div className={style.discount}>
              <span>{product.product_specific_price.discount_percent}%</span>
            </div>
          )}
          {!!product.total_qty ? (
            <div
              className={`${style.Remaining} ${
                product.total_qty <= 9 ? "" : "d-none"
              }`}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/remaining.svg`}
                alt="remaining"
              />
              <span>فقط {product.total_qty} عدد باقی‌مانده</span>
            </div>
          ) : (
            <div className={style.unavailable}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/stock.svg`}
                alt="stock"
              />
              <span>تموم شد،دیر رسیدی!</span>
            </div>
          )}

          <span
            className={
              !!product.total_qty ? style.overlay : style["overlay-unavilable"]
            }
          ></span>
        </div>
        <div className={style["product-info"]}>
          <div className="flex justify-center items-start w-full flex-col">
            <div className={style["brand-name"]}>
              {product.product_manufacturer_en_name}
            </div>
            <div className={style["product-title"]}>{product.product_name}</div>
          </div>
          <div className="flex justify-flex-start items-center w-full gap-2">
            {!!product.product_specific_price ? (
              <>
                <div className={style["product-price"]}>
                  {convertToFa(product.product_base_price)}
                </div>
                <div className={style["specific-price"]}>
                  {convertToFa(product.product_specific_price.specific_price)}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/icon/toman.svg`}
                    alt="toman"
                  />
                </div>
              </>
            ) : (
              <div className={style["no-discount"]}>
                {convertToFa(product.product_base_price)}
                <img
                  src={`${process.env.PUBLIC_URL}/assets/icon/toman.svg`}
                  alt="toman"
                />
              </div>
            )}
          </div>
        </div>
        {/* {product.club_label && (
          <div className={style.club}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/coin.svg`}
              alt=""
            />
            <span>{product.club_label.title}</span>
          </div>
        )} */}
      </a>
    </div>
  );
};

export default ProductSingle;
